import React, { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Offcanvas } from "react-bootstrap";
import { AuthContext } from "../../../../../../../Contexts/AuthContext/AuthProvider";
import MobileTradeSideBar from "../../../MobileTradeSideBar/MobileTradeSideBar";
import MobileTradingViewWidget from "../../../../../MobileTradingViewWidget/MobileTradingViewWidget";
import Loader from "../../../../../../Loader/Loader";
import MobileTradeHistory from "../../../MobileTradeHistory/MobileTradeHistory";
import LongModal from "./Modal/LongModal/LongModal";
import ShortModal from "./Modal/ShortModal/ShortModal";

const MobileStockBinaryTrade = () => {
  const { id } = useParams();
  const { authUser } = useContext(AuthContext);
  const [longmodalshow, setlongmodalshow] = useState(false);
  const [shortModalShow, setShortModalShow] = useState(false);

  const [marketData, setMarketData] = useState([]);
  const [symbol, setSymbol] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    if (id) {
      fetch(
        `https://api.wlffinance.org/api/user/trade/market/hot/view/${id}`,
        {
          method: "GET",
        }
      )
        .then((res) => res.json())
        .then((data) => {
          setSymbol(data?.data?.symbol);
          setMarketData(data?.data);
          setLoading(false);
        });
    }
  }, [id]);

  const [userData, setUserData] = useState([]);

  useEffect(() => {
    if (authUser?._id) {
      fetch(`https://api.wlffinance.org/api/user/auth/view/${authUser?._id}`, {
        method: "GET",
      })
        .then((res) => res.json())
        .then((data) => {
          setUserData(data.data);
        });
    }
  }, [authUser?._id]);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  if (loading) {
    return (
      <>
        <Loader></Loader>
      </>
    );
  } else {
    return (
      <>
        <Offcanvas
          show={show}
          onHide={handleClose}
          className="mobile-trade-offcanvas-area"
        >
          <MobileTradeSideBar handleClose={handleClose}></MobileTradeSideBar>
        </Offcanvas>

        <div className="d-flex justify-content-evenly align-items center  trade-page-btn">
          <div className="row gutters">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <div className="text-center">
                <Link className="user-btn1  active">Binary Trade</Link>
              </div>
            </div>
          </div>

          <div className="row gutters">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <div className="text-center">
                <Link to={`/user/live/trade/hot/${id}`} className="user-btn1 ">
                  Live Trade
                </Link>
              </div>
            </div>
          </div>
        </div>

        <section className=" mobile-trade-section user-dashboard">
          <div className="row">
            <div className="col-12">
              <div className="trade-area-posce">
                <div className="charts">
                  <div
                    className="charts__head"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasLeft"
                    aria-controls="offcanvasLeft"
                  >
                    <div className="d-flex gap-3">
                      <div className="nav" onClick={handleShow}>
                        <img
                          src="https://cryptolly.netlify.app/assets/media/images/icons/menu.svg"
                          alt="MENU"
                        />
                      </div>
                    </div>
                    <div className="nav">
                      <button
                        className="nav__link js-tabs-link active"
                        style={{ color: "lime" }}
                      >
                        $
                        {!isNaN(userData?.balance) &&
                          parseFloat(userData?.balance).toFixed(2)}
                      </button>
                    </div>
                  </div>
                </div>

                <div className="trade-charts-area-posce">
                  <MobileTradingViewWidget
                    symbol={symbol}
                  ></MobileTradingViewWidget>
                </div>
                <div className="d-flex gap-3">
                  <button
                    type="button"
                    className="btn btn-success  w-100 "
                    data-bs-toggle="modal"
                    style={{ borderRadius: "30px" }}
                    onClick={() => setlongmodalshow(true)}
                  >
                    Long
                  </button>

                  <button
                    type="button"
                    className="btn btn-danger  w-100"
                    data-bs-toggle="modal"
                    style={{ borderRadius: "30px" }}
                    onClick={() => setShortModalShow(true)}
                  >
                    Short
                  </button>
                </div>
              </div>
            </div>
          </div>

          <MobileTradeHistory />
        </section>

        <LongModal
          className="mobile-trade-modal-section posce-trade-modal"
          marketData={marketData}
          setlongmodalshow={setlongmodalshow}
          longmodalshow={longmodalshow}
          symbol={symbol}
          id={id}
          show={longmodalshow}
          onHide={() => setlongmodalshow(false)}
        />
        <ShortModal
          className="mobile-trade-modal-section posce-trade-modal "
          marketData={marketData}
          setShortModalShow={setShortModalShow}
          shortModalShow={shortModalShow}
          symbol={symbol}
          id={id}
          show={shortModalShow}
          onHide={() => setShortModalShow(false)}
        />
      </>
    );
  }
};

export default MobileStockBinaryTrade;
